// noinspection LongLine

import { createEntityAdapter } from '@reduxjs/toolkit'
import { rest, RestRequest } from 'msw'

import { LicensePlan, Organization, OrganizationId, UserRole } from '../../types/organization'
import { DemoProject, Project, ProjectTimelineItem } from '../../types/project'
import { ReportState } from '../../types/report'
import { Team, TeamId } from '../../types/team'
import { TeamUserStatus } from '../../types/user'

import {
	AUTHORIZED_USER,
	AUTHORIZED_USER_PERMISSIONS,
	LICENSE_TEXTS,
	USER_AGREEMENTS,
} from './mocks'

const RESPONSE_DELAY = undefined

const TOKEN_GENERATION_DELAY = 2000
const HTTP_STATUS_NOT_FOUND = 404

const projectsAdapter = createEntityAdapter<Project & { _teamId: TeamId }>()
const organizationsAdapter = createEntityAdapter<Organization>()

const mockedUserConfiguration = {}

let mockedUserLicenses = Object.assign({}, USER_AGREEMENTS)

let projects = projectsAdapter.getInitialState()
const entities: Array<Project & { _teamId: TeamId }> = [
	{
		id: '1',
		_teamId: 'Qodana',
		name: 'First awesome project',
		isDemo: false,
		url: 'https://example.com',
		lastReportId: '12',
		lastChecked: 'Wed May 11 2022 17:17:58 GMT+0200 (Central European Summer Time)',
		problems: { total: 668, critical: 2, high: 602, moderate: 60, low: 0, info: 4 },
	},
	{
		id: '2',
		_teamId: 'Qodana',
		name: 'Second awesome project',
		isDemo: false,
		url: 'https://example.com',
	},
	{
		id: '3',
		_teamId: 'Qodana',
		name: 'ASP.DA Site',
		isDemo: false,
		url: 'https://example.com/asp.da',
		problems: { total: 6, critical: 1, high: 0, moderate: 3, low: 0, info: 2 },
	},
	{
		id: '4',
		_teamId: 'Qodana',
		name: 'WordClick',
		isDemo: false,
		url: 'https://example.com/wordclick',
	},
]
projects = projectsAdapter.setAll(projects, entities)

let organizations = organizationsAdapter.getInitialState()
organizations = organizationsAdapter.setAll(organizations, [
	{
		id: '1',
		membersCount: 11,
		name: 'JetBrains',
		isPublic: false,
		licensePlan: LicensePlan.community,
		teamsCount: 20,
	},
	{
		id: '2',
		membersCount: 14,
		name: 'Demo projects',
		isPublic: true,
		licensePlan: LicensePlan.community,
		teamsCount: 30,
	},
	{
		id: '3',
		membersCount: 13,
		name: 'My Awesome Org Ltd',
		isPublic: false,
		licensePlan: LicensePlan.community,
		teamsCount: 40,
	},
])

let posts = {
	count: 0,
	items: [
		{
			body: 'When you’re tired of endless code reviews and debugging, you may start wondering if there are ways to automate tedious tasks without it backfiring on you later in development. If this is something you or your team are interested in, you may want to take a closer look at server-side static analysis. ',
			id: 1,
			learnMoreText: 'Read blog post',
			learnMoreUrl:
				'https://blog.jetbrains.com/qodana/2022/01/cut-time-on-code-reviews-and-project-planning-with-static-analysis/',
			tags: [
				{
					id: 0,
					name: 'Сode Review',
				},
				{
					id: 1,
					name: 'News',
				},
				{
					id: 2,
					name: 'Qodana',
				},
			],
			title: 'Cut Time on Code Reviews and Project Planning With Static Analysis',
		},
		{
			body: 'Qodana specializes in build quality management, delivering the static analysis smarts of IntelliJ Platform to project-level inspections. In May, we extended the platform with a second linter,  Clone Finder, which detects code duplicates. Today, we are happy to announce the EAP for License Audit to detect incompatible third-party licenses on which your code ...',
			id: 2,
			learnMoreText: 'Read blog post',
			learnMoreUrl: 'https://blog.jetbrains.com/qodana/2021/07/qodana-license-audit/',
			tags: [
				{
					id: 0,
					name: 'Features',
				},
				{
					id: 1,
					name: 'News',
				},
			],
			title: 'License Audit with Qodana',
		},
		{
			body: 'In December 2020, we announced the EAP for Qodana, which is rapidly evolving into a comprehensive platform that allows companies to perform multi-level evaluations of the quality of code they own, contract, or purchase.',
			id: 3,
			learnMoreText: 'Read blog post',
			learnMoreUrl:
				'https://blog.jetbrains.com/phpstorm/2021/05/qodana-clone-finder-early-access-program/',
			tags: [
				{
					id: 0,
					name: 'Features',
				},
				{
					id: 1,
					name: 'News',
				},
			],
			title: 'Qodana Clone Finder: Early Access Program',
		},
		{
			body: 'JetBrains IDEs are well known for their ability to understand code. They can track declarations, check references and types, and collect possible execution paths. Thanks to all this static analysis, you are able to...',
			id: 4,
			learnMoreText: 'Read blog post',
			learnMoreUrl:
				'https://blog.jetbrains.com/idea/2021/02/early-access-program-for-qodana-a-new-product-that-brings-the-smarts-of-jetbrains-ides-into-your-ci-pipeline/',
			tags: [
				{
					id: 0,
					name: 'Early Access Programm',
				},
				{
					id: 1,
					name: 'Tools',
				},
			],
			title:
				'Early Access Program for Qodana, a New Product That Brings the “Smarts” of JetBrains IDEs Into Your CI Pipeline',
		},
		{
			body: 'When you’re tired of endless code reviews and debugging, you may start wondering if there are ways to automate tedious tasks without it backfiring on you later in development. If this is something you or your team are interested in, you may want to take a closer look at server-side static analysis. ',
			id: 5,
			learnMoreText: 'Read blog post',
			learnMoreUrl:
				'https://blog.jetbrains.com/qodana/2022/01/cut-time-on-code-reviews-and-project-planning-with-static-analysis/',
			tags: [
				{
					id: 0,
					name: 'Сode Review',
				},
				{
					id: 1,
					name: 'News',
				},
				{
					id: 2,
					name: 'Qodana',
				},
			],
			title: 'Cut Time on Code Reviews and Project Planning With Static Analysis',
		},
		{
			body: 'Qodana specializes in build quality management, delivering the static analysis smarts of IntelliJ Platform to project-level inspections. In May, we extended the platform with a second linter,  Clone Finder, which detects code duplicates. Today, we are happy to announce the EAP for License Audit to detect incompatible third-party licenses on which your code ...',
			id: 6,
			learnMoreText: 'Read blog post',
			learnMoreUrl: 'https://blog.jetbrains.com/qodana/2021/07/qodana-license-audit/',
			tags: [
				{
					id: 0,
					name: 'Features',
				},
				{
					id: 1,
					name: 'News',
				},
			],
			title: 'License Audit with Qodana',
		},
		{
			body: 'In December 2020, we announced the EAP for Qodana, which is rapidly evolving into a comprehensive platform that allows companies to perform multi-level evaluations of the quality of code they own, contract, or purchase.',
			id: 7,
			learnMoreText: 'Read blog post',
			learnMoreUrl:
				'https://blog.jetbrains.com/phpstorm/2021/05/qodana-clone-finder-early-access-program/',
			tags: [
				{
					id: 0,
					name: 'Features',
				},
				{
					id: 1,
					name: 'News',
				},
			],
			title: 'Qodana Clone Finder: Early Access Program',
		},
		{
			body: 'JetBrains IDEs are well known for their ability to understand code. They can track declarations, check references and types, and collect possible execution paths. Thanks to all this static analysis, you are able to...',
			id: 8,
			learnMoreText: 'Read blog post',
			learnMoreUrl:
				'https://blog.jetbrains.com/idea/2021/02/early-access-program-for-qodana-a-new-product-that-brings-the-smarts-of-jetbrains-ides-into-your-ci-pipeline/',
			tags: [
				{
					id: 0,
					name: 'Early Access Programm',
				},
				{
					id: 1,
					name: 'Tools',
				},
			],
			title:
				'Early Access Program for Qodana, a New Product That Brings the “Smarts” of JetBrains IDEs Into Your CI Pipeline',
		},
	],
	next: 0,
	prev: 0,
}

const teams: Array<Team & { _orgId: OrganizationId }> = [
	{
		id: 'Qodana',
		_orgId: '1',
		name: 'Qodana',
		projectCount: 12,
		membersCount: 5,
		userStatus: TeamUserStatus.member,
	},
	{
		id: 'Space',
		_orgId: '1',
		name: 'Space',
		projectCount: 32,
		membersCount: 15,
		userStatus: TeamUserStatus.pendingMembershipRequest,
	},
	{
		id: 'PHPStorm',
		_orgId: '1',
		name: 'PHPStorm',
		projectCount: 2,
		membersCount: 6,
		userStatus: TeamUserStatus.notMember,
	},
	{ id: 'WebStorm', _orgId: '1', name: 'WebStorm', projectCount: 2, membersCount: 5 },
	{
		id: 'Net',
		_orgId: '2',
		name: '.Net',
		projectCount: 1,
		membersCount: 2,
		userStatus: TeamUserStatus.member,
	},
]

let startingId = 5

const projectTokens: Record<number, string> = {
	1: 'lasttoken from mock',
}

const timelineItemStates = Object.values(ReportState)

const generateTimelineItems = (count: number) => {
	const getRandomInt = (max: number) => {
		return Math.floor(Math.random() * max)
	}

	const generateCommit = (length: number) => {
		let commit = ''
		const characters = 'abcdefghijklmnopqrstuvwxyz0123456789'
		for (let i = 0; i < length; i++) {
			commit += characters[Math.floor(Math.random() * characters.length)]
		}
		return commit
	}

	const items: ProjectTimelineItem[] = []

	for (let i = count - 1; i >= 0; i--) {
		const state = timelineItemStates[getRandomInt(timelineItemStates.length)]

		items.push({
			createdAt: new Date(new Date().setDate(new Date().getDate() + i)).toISOString(),
			baselineCount:
				state === ReportState.failedToProcess || state === ReportState.uploaded
					? 0
					: getRandomInt(1000),
			problemsCount:
				state === ReportState.failedToProcess || state === ReportState.uploaded
					? 0
					: getRandomInt(1000),
			reportId: `reportId_${i}`,
			state,
			commit: generateCommit(40),
		})
	}

	return items
}
const timelineItems = generateTimelineItems(100)

export { projects }

export const handlers = [
	rest.get('/static/*', () => {
		/* Bypass this request, returning an actual response
		 * (it will be generated warning in console, see https://github.com/mswjs/msw/issues/676)
		 */
		return
	}),
	rest.get('/api/users/me', (req, res, ctx) => {
		return res(
			ctx.json({
				...AUTHORIZED_USER,
				configuration: mockedUserConfiguration,
			}),
		)
		// return res(ctx.status(401))
	}),
	rest.get('/api/users/me/permissions', (req, res, ctx) => {
		return res(ctx.delay(RESPONSE_DELAY), ctx.json(AUTHORIZED_USER_PERMISSIONS))
	}),
	rest.put('/api/users/me', async (req: RestRequest<{ configuration: unknown }>, res, ctx) => {
		const { configuration } = await req.json()
		Object.assign(mockedUserConfiguration, configuration)

		return res(
			ctx.delay(),
			ctx.json({
				id: 1,
				email: 'mocked.user@example.com',
				configuration: mockedUserConfiguration,
			}),
		)
	}),
	rest.get('/api/users/me/organizations', (req, res, ctx) => {
		return res(
			ctx.json({
				items: Object.values(organizations.entities).flatMap((organization) =>
					organization
						? [
								{
									id: organization.id,
									name: organization.name,
									role: 'ADMIN',
								},
						  ]
						: [],
				),
			}),
		)
	}),
	rest.get('/api/users/me/licenses', (req, res, ctx) => {
		return res(ctx.json(mockedUserLicenses))
	}),
	rest.put('/api/users/me/licenses/:licenseId', (req, res, ctx) => {
		const { licenseId } = req.params
		mockedUserLicenses = {
			accepted: [
				...mockedUserLicenses.accepted,
				...mockedUserLicenses.missing.filter((x) => x.id === +licenseId),
			],
			missing: mockedUserLicenses.missing.filter((x) => x.id !== +licenseId),
		}

		return res(ctx.json(mockedUserLicenses))
	}),
	rest.get('/api/licenses/:licenseId', (req, res, ctx) => {
		const licenseId = +req.params?.licenseId
		if (isNaN(licenseId)) {
			return res(ctx.status(404))
		}
		return res(ctx.json(LICENSE_TEXTS[licenseId]))
	}),
	rest.get('/api/projects', (req, res, ctx) => {
		const projectEntities = Object.values(projects.entities)

		return res(
			ctx.json(
				projectEntities.sort((a, b) => {
					const aId = String(a?.id),
						bId = String(b?.id)
					return aId === bId ? 0 : aId > bId ? 1 : -1
				}),
			),
		)
	}),
	rest.get('/api/organizations', (req, res, ctx) => {
		return res(ctx.delay(RESPONSE_DELAY), ctx.json(Object.values(organizations.entities)))
	}),

	rest.get('/api/organizations/:organizationId', (req, res, ctx) => {
		const { organizationId } = req.params
		const organization = Object.values(organizations.entities).find(
			(item) => item?.id === organizationId,
		)
		return res(ctx.delay(RESPONSE_DELAY), ctx.json(organization))
	}),

	rest.get('/api/organizations/:organizationId/projects', (req, res, ctx) => {
		return res(ctx.delay(RESPONSE_DELAY), ctx.json({ items: [], count: 0 }))
	}),

	rest.post('/api/projects/', async (req: RestRequest<Omit<DemoProject, 'id'>>, res, ctx) => {
		const { name, ...project } = await req.json()
		const newProject = {
			...project,
			id: `${startingId}`,
			name: name || `Random name #${startingId}`,
		}
		++startingId
		projects = projectsAdapter.addOne(projects, newProject)
		return res(ctx.delay(RESPONSE_DELAY), ctx.json(newProject))
	}),
	rest.delete('/api/projects/:projectId/', (req, res, ctx) => {
		const { projectId } = req.params
		projects = projectsAdapter.removeOne(projects, projectId as string)

		return res(ctx.delay(RESPONSE_DELAY))
	}),
	rest.put('/api/projects/:projectId/', async (req: RestRequest<{ name: string }>, res, ctx) => {
		const { projectId } = req.params
		const changes = await req.json()

		projects = projectsAdapter.updateOne(projects, { id: projectId as string, changes })
		return res(ctx.delay(RESPONSE_DELAY), ctx.json(projects.entities[projectId as string]))
	}),
	rest.get('/api/projects/:projectId', async (req, res, ctx) => {
		const { projectId } = req.params
		const projectInfo = {
			id: projectId,
			isDemo: false,
			languages: {},
			name: 'Cloud Backend',
			organizationId: '3oDrp',
			organizationSlug: 'jetbrains',
			slug: 'cloud_backend',
			teamId: 'wA6RA',
			teamSlug: 'qodana',
			url: '',
		}
		return res(ctx.delay(RESPONSE_DELAY), ctx.json(projectInfo))
	}),
	rest.post('/api/projects/:projectId/tokens/', (req, res, ctx) => {
		const { projectId } = req.params

		let token = btoa(Math.random() + 'generated.token.verylongstring')
		setTimeout(() => {
			projectTokens[Number(projectId)] = token
		}, TOKEN_GENERATION_DELAY)

		return res(
			ctx.delay(TOKEN_GENERATION_DELAY),
			ctx.json({
				id: projectId,
				token,
			}),
		)
	}),
	rest.post('/api/organizations/', async (req: RestRequest<Omit<Organization, 'id'>>, res, ctx) => {
		const organization = await req.json()
		const newOrganization = {
			...organization,
			id: `${startingId}`,
		}
		++startingId
		organizations = organizationsAdapter.addOne(organizations, newOrganization)
		return res(ctx.delay(2000), ctx.json(newOrganization))
	}),
	rest.get('/api/projects/:projectId/tokens', (req, res, ctx) => {
		const { projectId } = req.params

		return res(
			ctx.delay(RESPONSE_DELAY),
			ctx.json({
				count: projectTokens[Number(projectId)]?.length || 0,
				items: projectTokens[Number(projectId)] || [],
			}),
		)
	}),
	rest.get('/api/projects/:projectId/branches', (req, res, ctx) => {
		const { projectId } = req.params

		if (!projects.entities[projectId as string]) {
			return res(ctx.delay(RESPONSE_DELAY), ctx.status(HTTP_STATUS_NOT_FOUND))
		}

		return res(
			ctx.delay(RESPONSE_DELAY),
			ctx.json({
				branches: ['master', 'refs/heads/develop'],
				default: 'refs/heads/develop',
			}),
		)
	}),
	rest.get('/api/reports/:reportId/files', (req, res, ctx) => {
		return res(ctx.delay(RESPONSE_DELAY), ctx.json([]))
	}),

	rest.get('/api/tips', (req, res, ctx) => {
		return res(ctx.delay(RESPONSE_DELAY), ctx.json(posts))
	}),

	rest.get('/api/organizations/:organizationId/teams', (req, res, ctx) => {
		return res(ctx.delay(RESPONSE_DELAY), ctx.json({ items: teams }))
	}),

	rest.get('/api/teams/:teamId', (req, res, ctx) => {
		const { teamId } = req.params
		const team = teams.find((item) => item.id === teamId)
		return res(ctx.delay(RESPONSE_DELAY), ctx.json(team))
	}),

	rest.get('/api/teams/:teamId/projects', (req, res, ctx) => {
		const { teamId } = req.params

		const teamProjects = Object.values(projects.entities).filter((p) => p && p._teamId === teamId)

		return res(
			ctx.delay(5000),
			ctx.json({
				items: teamProjects,
				count: teamProjects.length,
			}),
		)
	}),

	rest.post('/api/teams/:teamId/projects/', async (req, res, ctx) => {
		const { name = `Random name ${startingId}`, ...project } = await req.json()

		const id = `${startingId}`

		const newProject = {
			...project,
			id,
			name,
		}
		++startingId
		projects = projectsAdapter.addOne(projects, newProject)

		return res(
			ctx.delay(RESPONSE_DELAY),
			ctx.json({
				id,
				name,
				slug: name.toLowerCase().replace(' ', '_'),
			}),
		)
	}),

	rest.get('/api/teams/:teamId/users', (req, res, ctx) => {
		const { teamId } = req.params
		const users =
			teamId === 'Qodana'
				? [
						{ id: '1', email: 'test@test.com', role: 'ADMIN', userName: 'Test Test' },
						{
							id: '2',
							email: 'test2@test2.com',
							role: 'ADMIN',
							userName: 'Test2 Test2',
							isActive: true,
						},
				  ]
				: []

		return res(ctx.delay(RESPONSE_DELAY), ctx.json({ items: users }))
	}),

	rest.get('/api/projects/:projectId/timeline', (req, res, ctx) => {
		const offset = Number(req.url.searchParams.get('offset')) || 0
		const limit = Number(req.url.searchParams.get('limit')) || 50

		const timelineItemsCount = timelineItems.length

		return res(
			ctx.delay(RESPONSE_DELAY),
			ctx.json({
				count: timelineItemsCount,
				items: timelineItems.slice(
					offset < timelineItemsCount ? offset : timelineItemsCount - 1,
					offset + limit < timelineItemsCount ? limit : timelineItemsCount,
				),
				next:
					timelineItemsCount - offset - limit < 0 ? undefined : timelineItemsCount - offset - limit,
				prev: offset > 0 ? timelineItemsCount - offset : undefined,
			}),
		)
	}),

	rest.get('/api/organizations/1/users', (req, res, ctx) => {
		return res(
			ctx.delay(RESPONSE_DELAY),
			ctx.json([
				{
					email: 'mocked.user@example.com',
					id: 1,
					isActive: true,
					role: UserRole.admin,
				},
			]),
		)
	}),

	rest.get('/api/organizations/:organizationId/contributors', (req, res, ctx) => {
		return res(
			ctx.delay(RESPONSE_DELAY),
			ctx.json({
				items: [
					{ contributions: 14, email: 'john.smith@example.com', name: 'John Smith' },
					{ contributions: 10, email: 'robert.johnson@example.com', name: 'Robert Johnson' },
					{ contributions: 9, email: 'michael.brown@example.com', name: 'Michael Brown' },
				],
			}),
		)
	}),
]
